import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-play\"><rect x=\".5\" y=\".5\" width=\"29\" height=\"29\" rx=\"14.5\" fill=\"#fff\" stroke=\"currentColor\" /><path d=\"M21 15.5 12 21V10l9 5.5Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol